// Owner console → Payment methods (BILLING-001, D-086): the one place for Adyvance's QR payment, bank
// transfer and Fonepay Dynamic QR, and the read-only summary other sections show.
export const payMethodsStrings = {
  qr: {
    title: "QR payment",
    help: "Shops scan it when they add money to their Adyvance Wallet and send the receipt.",
    upload: "Upload QR",
    replace: "Replace the QR",
    name: "Name under the QR",
    formats: "JPG, PNG or WebP.",
  },
  bank: {
    title: "Bank transfer",
    help: "Shops transfer to this account when they add money and send the receipt.",
    bank: "Bank",
    name: "Account name",
    number: "Account number",
  },
  fonepay: "Fonepay QR",
  fonepayWeb: "Fonepay checkout",
  note: "Note for shops (QR and bank)",
  notePh: "For example: write your shop name in the remarks",
  status: {
    on: "On",
    off: "Off",
    missing: "Not set",
    instant: "On: paid instantly",
  },
  save: "Save QR and bank",
  discard: "Discard",
  saved: "Payment methods saved",
  upToDate: "QR and bank are up to date",
  card: {
    title: "How shops pay",
    edit: "Edit payment methods",
    leadWallet:
      "Shops add money with these. Every purchase is paid from the wallet or directly by Fonepay QR.",
    leadSms: "Shops buy SMS credits from their Adyvance Wallet or directly by Fonepay QR.",
    leadAds:
      "Shops pay for ads from their Adyvance Wallet or directly by Fonepay QR. They add money with these.",
    noAccess: "Only the owner and operators can see the payment methods.",
  },
} as const;
